<!-- Navbar Start -->
<div class="container-fluid fixed-top px-0" data-aos="fade-in" data-aos-duration="1000">
  <div class="container">
    <div class="row">
      <nav class="navbar navbar-expand-lg navbar-light px-lg-0 py-lg-3" data-aos="fade-up" data-aos-duration="1000">
        <a routerLink="/" class="navbar-brand ms-4 ms-lg-0 pt-0">
          <img class="img-fluid logo-img" data-aos="fade-up" data-aos-duration="1000" src="assets/brand/logo.png" width="" height="100" alt="logo" />
        </a>
        <button type="button" class="navbar-toggler me-4" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse">
          <div class="navbar-nav ms-auto p-4 p-lg-0" app-topmenu></div>
        </div>
      </nav>
    </div>
  </div>
</div>
<!-- Navbar End -->

<!-- Carousel Start -->
<div id="myCarousel" class="carousel slide carousel-fade" data-bs-ride="carousel" data-aos="fade-in" data-aos-duration="1000">
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src="assets/brand/banner-1.png" class="d-block w-100">

      <div class="container">
        <div class="carousel-caption text-end" data-aos="fade-left" data-aos-duration="1000">
          <h5 class="heading-h5">THOUSANDS OF SKILL BUILDING VIDEOS</h5>
          <h1 class="heading-h1 py-2">Resources for <span class="text-gold">Coaches</span>,<br><span
              class="text-gold">Choreographers</span>, and <span class="text-gold">Gym Owners</span>.
          </h1>
          <p class="italic">Skills & Transitions, Drills & More!.</p>
          <p class="py-sm-3 py-md-4 py-lg-5" data-aos="fade-left" data-aos-duration="1000">
            <a class="btn btn-lg btn-gold" routerLink="/signup">SIGN UP</a>
          </p>
        </div>
      </div>
    </div>
    <div class="carousel-item">
      <img src="assets/brand/banner-2.png" class="d-block w-100">

      <div class="container">
        <div class="carousel-caption text-end" data-aos="fade-left" data-aos-duration="1000">
          <h5 class="heading-h5">BUILDING COACHES</h5>
          <h1 class="heading-h1 py-2"><span class="text-gold">Forge</span> gives you the tools <br>you need for <span class="text-gold">success</span>.
        </h1>
          <p class="italic">Now you’re the expert!</p>
          <p class="py-sm-3 py-md-4 py-lg-5" data-aos="fade-left" data-aos-duration="1000">
            <a class="btn btn-lg btn-gold" routerLink="/signup">SIGN UP</a>
          </p>
        </div>
      </div>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#myCarousel" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#myCarousel" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
<!-- Carousel End -->